// material-ui
import { Stack } from '@mui/material';

/**
 * Footer เลย์เอาต์ — ถ้าไม่มีเนื้อหาให้แสดง ไม่เรนเดอร์ DOM
 * (กัน padding/margin ของ Stack ทำให้เลื่อนลงไปเจอพื้นที่ว่างโดยไม่มี UI)
 *
 * เมื่อต้องการแสดงลิงก์/ลิขสิทธิ์ ให้ตั้ง hasFooterContent เป็น true และใส่ children ใน Stack ด้านล่าง
 */
const hasFooterContent = false;

const Footer = () => {
  if (!hasFooterContent) {
    return null;
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        p: '24px 16px 0px',
        mt: 2
      }}
    >
      <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
        {/* Typography, Link ฯลฯ */}
      </Stack>
    </Stack>
  );
};

export default Footer;
